import {ISection2CompleteForm} from '@models/onboarding-review/section2-complete-form';
import {IConfigurationValuesService} from '@services/ConfigurationValuesService';
import {action, observable} from 'mobx';

export interface ISection2CompleteStore extends Readonly<ISection2CompleteForm> {
    initialise(): void;
    setAcceptedElectronicSignature(accepted: boolean): void;
    setDocumentsPhysicallyExamined(examined: boolean): void;
}

export class Section2CompleteStore implements ISection2CompleteStore {
    @observable
    employeeFirstDayEmployment: string = '';

    @observable
    acceptedElectronicSignature: boolean = false;

    @observable
    documentsPhysicallyExamined: boolean = false;

    constructor(
        private configurationValuesService: IConfigurationValuesService
    ) {
    }

    @action.bound
    initialise() {
        this.acceptedElectronicSignature = false;
        this.documentsPhysicallyExamined = this.configurationValuesService.hideDocumentsPhysicallyExamined === true;
    }

    @action.bound
    setAcceptedElectronicSignature(accepted: boolean) {
        this.acceptedElectronicSignature = accepted;
    }

    @action.bound
    setDocumentsPhysicallyExamined(examined: boolean) {
        this.documentsPhysicallyExamined = examined;
    }
}



// WEBPACK FOOTER //
// ./src/stores/onboarding-review/section2-complete-store.ts